/* eslint-disable */
export default [{
    header: 'Finances', action: 'read_transactions_fund_history', resource: 'Caisse Générale',
}, {
    title: 'Caisse Générale',
    route: 'fund-histories-list',
    icon: 'DollarSignIcon',
    action: 'read_transactions_fund_history',
    resource: 'Caisse Générale',
}, {
    title: 'Fond Dédié',
    route: 'dedicated-fund-list',
    icon: 'ShareIcon',
    action: 'read_deductions_fund_history',
    resource: 'Fond Dédié',
}, {
    title: 'Banques',
    route: 'apps-banks-list',
    icon: 'CreditCardIcon',
    action: 'read_bank_histories',
    resource: 'Banques',
}, {
    title: "Statistiques",
    route: "apps-statistic",
    icon: "TrendingUpIcon",
    action: 'read_statistic',
    resource: 'Statistiques',
}, {
    title: "Facturation",
    route: "apps-invoice-list",
    icon: "FileIcon",
    action: 'read_all_invoices',
    resource: 'Facturation',
}, {
    title: "Clients",
    route: "apps-clients-list",
    icon: "BriefcaseIcon",
    action: 'read_all_clients',
    resource: 'Clients',
}]